import styled from '@emotion/styled';
import dayjs from 'dayjs';
import React from 'react';
import { NavLink } from 'react-router-dom';
import useGetByPageType from '../../../components/Website/hooks/useGetByPageType';
import useGetProjectInfo from '../../../hooks/useGetProjectInfo';
import { L } from '../../../lib/i18n';
import { colors } from '../../../components/Shared/Style/colors';
import VerticalMoreIcon from '../../../components/Icon/vertical-dots.svg';

const StyledNavItem = styled.li({});
const StyledNavLink = styled(NavLink)(({ theme }) => ({
    padding: '10px 20px',
    borderLeft: '6px solid',
    width: '100%',
    marginBottom: '1rem',
    borderColor: '#29CC97',
    backgroundColor: 'white',
    cursor: 'pointer',
    borderRadius: '5px',
    listStyle: 'none',
    textDecoration: 'none',
    color: 'black',
    display: 'block',
    boxShadow: '0px 1px 14px rgba(0, 0, 0, 0.1)',
    '&.active': {
        boxShadow: `0 0 3px ${theme.colors.primary}`,
    },
    '&.noValue': {
        borderColor: 'gray',
    },
}));
const SmallInfo = styled.div({
    fontSize: '0.8rem',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1rem',
});

const IconWrapper = styled.div({
    width: '1rem',
    opacity: 0,
});

const FlexWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
});

const Wrapper = styled.div({
    marginLeft: '1rem',
});

const StaticHomePageMenuItem = () => {
    const { data: homePageData } = useGetByPageType('home_page');
    const { data: projectInfo } = useGetProjectInfo();
    return (
        <StyledNavItem onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
            <StyledNavLink exact to={`/public-site/`} className={homePageData?.description ? '' : 'noValue'}>
                <FlexWrapper>
                    <IconWrapper>
                        <VerticalMoreIcon />
                    </IconWrapper>
                    <Wrapper>
                        <h1>{L('homepage')}</h1>
                        <SmallInfo>
                            <span>
                                {L('created_by')} <b>{projectInfo?.name}</b>
                            </span>
                            <span>
                                {L('last_edited')}{' '}
                                <b>
                                    {homePageData
                                        ? dayjs(homePageData.updated_at).format('YYYY-MM-D')
                                        : L('never_edited')}
                                </b>
                            </span>
                        </SmallInfo>
                    </Wrapper>
                </FlexWrapper>
            </StyledNavLink>
        </StyledNavItem>
    );
};

export default StaticHomePageMenuItem;
